import { useQueryClient } from '@tanstack/react-query'

import { useErrandsServicePatchV1IndividualsByIndividualIdErrandsByErrandId } from '../client/queries'
import { useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey } from '../client/queries/common'

export const useUpdateErrand = () => {
  const queryClient = useQueryClient()

  return useErrandsServicePatchV1IndividualsByIndividualIdErrandsByErrandId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
      })
    },
  })
}
